import axios from 'axios';
import urls from './urls';
import {tokenHeader} from './headers';

let url = (method) => {
  let url = `${urls.API_ROOT}/api/v1/${method}`;
  if (url.indexOf('?') >= 0) return url;
  if (url.split('').pop() !== '/') url += '/';
  return url;
};

axios.interceptors.response.use(null, function(error) {
  if (error.response && error.response.status === 401) {
    localStorage.clear();
    window.location = '/';
  }
  return Promise.reject(error);
});

export default {
  pathToWkt(path, id, isNew) {
    let polygonPaths = []
    path.getArray().forEach((path, index) => {
      polygonPaths.push(path.lng() + ' ' + path.lat())
    });
    if (isNew) polygonPaths.push(path.getArray()[0].lng() + ' ' + path.getArray()[0].lat())
    return 'SRID=' + id + ';MULTIPOLYGON (((' + polygonPaths.join(',') + ')))'
  },
  marker(marker) {
    return `${urls.API_ROOT}${marker}`;
  },
  CancelToken: false,
  source: false,
  lastCallEndPoint: false,
  cancelableGet(method, token) {
    this.CancelToken = axios.CancelToken;
    this.source = this.CancelToken.source();
    token.cancelToken = this.source.token;
    return { 
      promise: axios.get(method, token), 
      source: this.source
    }
  },
  get(method, cancelable) {
    const lastCallEndPoint = url(method);
    if (cancelable) {
      if (this.lastCallEndPoint === lastCallEndPoint.split('?')[0] && this.source) this.source.cancel(this.lastCallEndPoint + ': Duplicate request');
      const request = this.cancelableGet(lastCallEndPoint, tokenHeader());
      this.lastCallEndPoint = lastCallEndPoint.split('?')[0];
      this.source = request.source;
      return request.promise;
    } else {
      return axios.get(lastCallEndPoint, tokenHeader());
    }
  },
  post(method, data) {
    return axios.post(url(method), data, tokenHeader());
  },
  put(method, data) {
    return axios.put(url(method), data, tokenHeader());
  },
  delete(method, data) {
    let token = tokenHeader();
    token.data = data;
    return axios.delete(url(method), token);
  }
}


// WEBPACK FOOTER //
// ./src/utils/api.js